import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { combineLatest, shareReplay } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';

import { SearchInputComponent } from '../../../../../widgets/search-input/components/search-input/search-input.component';
import { ScrollService } from '../../../../services/scroll.service';
import { MainNavItemsService } from '../../services/main-nav-items.service';
import { MainNavMobileService } from '../../services/main-nav-mobile.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-mobile',
  templateUrl: './main-nav-mobile.component.html',
  styleUrl: './main-nav-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavMobileComponent {
  @ViewChild('searchInput') searchRef: SearchInputComponent | undefined;

  loggedUser$ = this.nav.loggedUser$;

  searchVisible$ = combineLatest([
    this.nav.isPlatform$,
    // TODO is probably not needed for conditions
    // this.mobile.inSearch$.pipe(map((inSearch) => !inSearch)),
    this.nav.activeUrl$.pipe(map(activeUrl => activeUrl !== 'search'))
  ]).pipe(
    map(all => all.every(item => item)),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  // (nav.isPlatform$ | async) && ((mobile.inSearch$ | async) === false) && (nav.activeUrl$ | async) !== 'search'

  logoUrl$ = this.nav.isPlatform$.pipe(
    map(isPlatform => (isPlatform ? '/assets/images/logo/logo-sh-small-turquoise.svg' : '/assets/images/logo/logo-smarthead-business-turquoise.svg'))
  );

  logoMenuUrl$ = this.nav.isPlatform$.pipe(
    map(isPlatform => (isPlatform ? '/assets/images/logo/logo-smarthead-turquoise.svg' : '/assets/images/logo/logo-smarthead-business-turquoise.svg'))
  );

  constructor(
    public items: MainNavItemsService,
    public mobile: MainNavMobileService,
    private router: Router,
    private scrollService: ScrollService,
    public nav: MainNavService
  ) {}

  open() {
    this.mobile.open$.next(true);
    this.scrollService.lock();
  }

  onClose() {
    if (this.mobile.open$.value) {
      this.mobile.open$.next(false);
      this.scrollService.unlock();
    }
  }

  triggerSearch() {
    this.mobile.inSearch$.next(true);
    setTimeout(() => {
      this.searchRef?.inputRef?.nativeElement.focus();
    });
  }

  onCloseSearch() {
    this.mobile.inSearch$.next(false);
  }

  onCloseMenu() {
    this.onClose();
    this.onCloseSearch();
  }
}
